import get from 'lodash/get';
import compact from 'lodash/compact';
import Catalyst from '@Services/Catalyst';
import { concatLowerCase } from '@Utils/String';
import { citations, reactions } from '@Constants';
import isAIEnhancedPreviewItem from '@Containers/ResultsPreview/utils';

const AI_VIEW_RESULTS_BUTTON_TYPES = {
  [citations]: 'rx2:results-preview-page:view-results:ai:documents',
  [reactions]: 'rx2:results-preview-page:view-results:ai:reactions',
};

export function generatePreviewTrackingSections(feature, contextTitle = '') {
  return compact([Catalyst.getPrefix(), 'query', 'preview', concatLowerCase(contextTitle), feature]);
}
export function trackPreviewFeature(feature, resultItem) {
  const sections = generatePreviewTrackingSections(feature, get(resultItem, 'title'));

  Catalyst.trackProductFeature(sections.join(':'));
}

export function trackAIViewResults(previewItem) {
  const buttonType = AI_VIEW_RESULTS_BUTTON_TYPES[previewItem?.context];

  if (!buttonType || !isAIEnhancedPreviewItem(previewItem)) return;

  Catalyst.trackEvent('buttonClick', {
    buttonType,
  });
}
